import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./navegation/loginPage";
import MainMenu from "./navegation/mainMenu";
import SalesMenu from "./navegation/salesMenu";
import SalesArticleMenu from "./navegation/salesArticleMenu";
import CashMovementsMenu from "./navegation/cashMovementsMenu";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/menu" element={<MainMenu />} />
        <Route path="/ventas" element={<SalesMenu />} />
        <Route path="/ventas-por-articulo" element={<SalesArticleMenu />} />
        <Route path="/movimientos-de-caja" element={<CashMovementsMenu />} />
      </Routes>
    </Router>
  );
};


export default App;

